import AuditDrawer from "~/adminApp/components/AuditDrawer"

import { Termination, TerminationState } from "@oysterhr/schema"
import {
  PillField,
  TextField,
  UserField,
  DateField,
  Label,
  ActorField,
} from "~/adminApp/pages/EmploymentPage/infoFields"
import { BadgeVariation } from "@oysterhr/ui"

const statePillConfig: { [key: string]: { text: string; variation: BadgeVariation } } = {
  [TerminationState.Initiated]: {
    text: "Initiated",
    variation: "info",
  },
  [TerminationState.Approved]: {
    text: "Approved",
    variation: "warning",
  },
  [TerminationState.CancellationRequested]: {
    text: "Cancellation requested",
    variation: "error",
  },
  [TerminationState.Cancelled]: {
    text: "Canceled",
    variation: "gray",
  },
  [TerminationState.Terminated]: {
    text: "Terminated",
    variation: "success",
  },
}

export const StatusField = ({ termination }: { termination?: Termination }) => {
  if (!termination) return null

  const pillConfig = statePillConfig[termination.state]
  return <PillField label="Status" value={pillConfig.text} variation={pillConfig.variation} />
}

type TerminationRequestProps = {
  termination: Termination
  noStatus?: boolean
}

const TerminationRequest = ({ termination, noStatus }: TerminationRequestProps) => {
  return (
    <div key={termination.id}>
      <div className="grid grid-cols-2 text-sm">
        {!noStatus && <StatusField termination={termination} />}
        <DateField label="Proposed date for termination" dateString={termination.proposedDate} />
        <DateField label="Request received on" dateString={termination.initiatedAt} />
        <Label label="Requested by">
          <ActorField actor={termination.requestor} />
        </Label>

        <UserField
          label="Offboarding Specialist"
          user={termination.offboardingSpecialist}
          showEmail={true}
        />

        {termination.approver && <UserField label="Approved by" user={termination.approver} />}
        {termination.cancelledBy && (
          <UserField label="Canceled by" user={termination.cancelledBy} />
        )}
        {termination.cancelledAt && (
          <DateField label="Canceled on" dateString={termination.cancelledAt} />
        )}
        {termination.cancelReason?.length && (
          <div className="col-span-2">
            <TextField label="Termination cancellation reason" value={termination.cancelReason} />
          </div>
        )}
        <div className="col-span-2 mb-4">
          History of changes
          <div className="mb-4 mt-1 font-medium text-gray-400">
            <AuditDrawer objectId={termination.id} label="View" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TerminationRequest
